import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { NavParams, ViewController, Loading, LoadingController, Modal } from "ionic-angular";
import { ManualPointService } from "../../../services/manual-point.service";
import { Storage } from "@ionic/storage";
import  * as jsPDF  from  "jspdf";

@Component({
    selector: "comments-details",
    templateUrl: "comments-details.html"
})
export class CommentsDetailsComponent {
    @Output() sendPdfData=new EventEmitter();
    constructor(
        private navParams: NavParams, 
        private viewCtrl: ViewController, 
        private manualPointService: ManualPointService,
        private storage: Storage,
        private loadingCtrl: LoadingController
    ) {
        //this.pdfData = this.navParams.get("pdfData");

    }
    cancel()
    {
        this.viewCtrl.dismiss();
    }

    send()
    {
        this.sendPdfData.emit(null);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/comments-details/comments-details.component.ts